
import Component from '../../../assets/scripts/modules/component'
import { getCookie } from '../../../assets/scripts/utilities/simple-cookie.js'
import { setConsentCookie } from '../../../assets/scripts/utilities/datalayer.consent.js'

export default class CookiePreferencesComponent extends Component {
  init () {
    this.input = this.element.querySelector('.toggle-field input')

    if (!this.input) {
      return
    }

    this.input.addEventListener('click', () => requestAnimationFrame(() => this.setCookie()))
    this.setValue()

    window.addEventListener('cookie-preferences-changed', () => this.setValue())
  }

  setCookie () {
    setConsentCookie(this.input.name + '-cookies', this.input.checked === true ? 'yes' : 'no')
  }

  setValue () {
    this.input.checked = (getCookie(this.input.name + '-cookies') === 'yes')
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.cookie-preferences').forEach(element => {
  element.instance = element.instance || new CookiePreferencesComponent(element)
}))
